module.exports = __webpack_public_path__ + "static/media/empty_loading.2a0d5122.png";